import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule } from '@angular/forms';
import * as moment from 'moment';
import { CalendarModule } from 'primeng/calendar';
import { debounceTime, distinctUntilChanged, filter, Subject } from 'rxjs';
import { RoleManagementService } from 'src/app/module/master/component/role-managements/role-management.service';
import { masterService } from 'src/app/module/master/services/master.service';
import { wageService } from 'src/app/module/wages/services/wage.service';
import { SharedService } from 'src/app/shared/shared.service';
import { TabService } from 'src/app/shared/tab.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent {
  @Input() showOutboundAttributes = false;
  @Input() showDateRange: boolean = false;
  @Input() warehouseList: any[] = [];
  @Input() accounts: any[] = [];
  @Input() showCustomer: boolean = false;
  @Input() customerMultiple: boolean = false;

  @Input() orderNumber : boolean = false
  @Input() orderStatus : boolean = false
  @Input() AttendanceStatus : boolean = false
  
  @Input() DateofPlacement : boolean = false
  @Input() showDate: boolean = false;
  @Input() showWarehouse: boolean = false;
  @Input() warehouseMultiple: boolean = false;
  @Input() showMapping: boolean = false;
  @Input() mappingMultiple: boolean = true;
  
  @Input() showCustomerAndWarehouse: boolean = false;
  @Input() showStatus?: boolean;
  @Input() showZone: boolean = false;
  @Input() showCity: boolean = false;
  @Input() showRegion: boolean = false;
  @Input() showExpenseType: boolean = false;
  @Input() showFY: boolean = false;
  @Input() showMonth: boolean = false;
  @Input() showBillingType: boolean = false;
  @Input() showUnitsOfMeasurement: boolean = false;
  @Input() showExpensesHead: boolean = false;
  @Input() showInvoiceStatus: boolean = false;
  @Input() showVendor: boolean = false;
  @Input() showVendorCode: boolean = false;
  @Input() showCategory: boolean = false;
  @Input() categoryFilterKey: string = 'CATEGORY_IN';
  @Input() categoryList: any[] = [];
  @Input() showExpenseMode: boolean = false;
  @Input() showUserName: boolean = false;
  @Input() showUserEmail: boolean = false;
  @Input() showUserMobileNo: boolean = false;
  @Input() showBudgetType: boolean = false;
  @Input() showDesignation: boolean = false;
  @Input() showOwnershipType: boolean = false;
  @Input() showWarehouseType: boolean = false;
  @Input() showDepartment: boolean = false;
  @Input() showExpenseCategory: boolean = false;
  @Input() showRoleName: boolean = false;
  @Input() showEmployeeName: boolean = false;
  @Input() showEmployeeCode: boolean = false;
  @Input() showCustShortName: boolean = false;
  @Input() showInvoiceNo: boolean = false;
  @Input() showQuickCodeName: boolean = false;
  @Input() showCurrentApproval:boolean = false;
  @Input() showUserAgeing:boolean = false;
  @Input() showDateFilter: boolean = false;
  @Input() showInvoiceId: boolean = false;
  @Input() showStateName : boolean = false
  @Input() showCityName: boolean = false
  @Input() showCityCode: boolean = false
  @Input() routeCode: boolean = false
  @Input() sourceCity: boolean = false
  @Input() destinationCity: boolean = false
  @Input() ShowVehicleType : boolean = false
  @Input() ContactNumber : boolean = false
  @Input() ContactEmail : boolean = false
  @Input() showUserCode : boolean = false
  @Input() AadharNumber : boolean = false
  @Input() showCustomerName : boolean = false
  @Input() userType : boolean = false
  @Input() showComponentType : boolean = false
  @Input() showCalculationType : boolean = false
  @Input() showStateList : boolean = false
  @Input() showName : boolean = false
  @Input() ComponentType : boolean = false
  @Input() showOrganization : boolean = false
  @Input() skillGroup : boolean = false
  @Input() showShift : boolean = false
  @Input() referenceId : boolean = false
  @Input() useAccountIdFilter: boolean = false;
  @Input() showCreatedBy: boolean = false;
  @Input() showProductName: boolean = false;
  @Input() showProductSku: boolean = false;
  @Input() showProductUpc: boolean = false;
  @Input() showProduct: boolean = false;
  @Input() productList: any[] = [];
  @Input() showInventoryQuantity: boolean = false;
  @Input() customerWarehouseLabel: string = 'Customer & Warehouse';
  /** Set to false when multiple views on one route have independent filters. */
  @Input() persistFilters: boolean = true;
  @Input() showPurchaseRequisitionId: boolean = false;
  @Input() showPurchaseOrderReference: boolean = false;
  @Input() showBusinessOwner: boolean = false;
  @Input() showPriority: boolean = false;
  @Input() customStatusList: any[] = [];
  @Input() customPriorityList: any[] = [];
  

  // Output events to notify parent component
  @Output() filterChange = new EventEmitter<any>();
  @Output() resetFilters = new EventEmitter<void>();

  searchForm: FormGroup;
  searchDropDownToggle: boolean = false

  category: any;
  clientId: any;
  customerModel: any;
  warehouseFilter: any = [];
  selectedCategories: any[] = []
  tabFilter: any
  allCatagory:any;
  sendCatagoryId:any;
  zoneList:any;
  regionList:any;
  cityList:any;
  expenseTypeList:any;
  financialYearList:any;
  date: Date[] | undefined;
  wareHouseList:any;
  accountMappingList:any;
  budgetType:any;
  designation:any;
  accountLists: any;
  ownershipType:any;
  whType: any;
  department: any;
  expenseCategory: any;
  roleList: any;
  expenseMode: any;
  vendorsList: any;
  EmployeesList: any;
  searchFilterList: any;
  selectedMappingIds: any;
  rangeDates: Date[] | undefined;
  searchExpenseFilterList: any;
  selectedOption :any = "";
  showCustomDateRange: boolean = false;
  dateRangePayload: any[] = [];
  postData: any;
  filters: any;
  today: Date = new Date(); 
  statusList= [
    {
      name:'Active'
    },
    {
      name:'Inactive'
    }
  ];
  statusListAttendance  = [
  { name: 'ReviewNeeded', label: 'Review Needed' },
  { name: 'Approved', label: 'Approved' },
  { name: 'PendingForApproval', label: 'Pending For Approval' }
];
  locationLists: any;
  componentTypesList:any
  calculationTypesList:any
  stateList: any;
  organizationList: any;
  skillGroupList: any;
  mappingList: any;
  shiftList: any;
  constructor(private tabService: TabService,private masterService: masterService,private sharedService: SharedService,
    private roleManagementService: RoleManagementService, private wageService:wageService) {
    this.searchForm = new FormGroup({
      CUSTOMER_ID_IN: new FormControl(''),
      PR_ID_IN: new FormControl(''),
      PO_REF_CODE_IN: new FormControl(''),
      CREATED_BY: new FormControl(''),
      BUSINESS_OWNER_ID_IN: new FormControl(''),
      PRIORITY_IN: new FormControl(''),
      MAPPING_IN: new FormControl(''),
      WAREHOUSE_ID_IN: new FormControl(''),
      STATUS_IN: new FormControl(),
      ZONE_IN: new FormControl(''),
      REGION_IN: new FormControl(''),
      CITY: new FormControl(''),
      EXPENSE_IN: new FormControl(''),
      YEAR_IN: new FormControl(''),
      DUMMY_FILTER_TWO: new FormControl(''), // DUMMY_FILTER_TWO IS USED FOR MONTH
      DUMMY_FILTER_THREE: new FormControl(''), // DUMMY_FILTER_THREE IS USED FOR Custom Range
      FROM_DATE: new FormControl(''),
      TO_DATE: new FormControl(''),
      CREATED_FROM_DATE: new FormControl(''),
      CREATED_TO_DATE: new FormControl(''),
      BILLINGTYPE: new FormControl(''),
      UNITOFMEASUREMENT: new FormControl(''),
      EXPENSESHEAD: new FormControl(''),
      INVOICESTATUS: new FormControl(''),
      VENDOR: new FormControl(''),
      CATEGORY_IN: new FormControl([]),
      CATEGORY_ID_IN: new FormControl([]),
      PRODUCT_CATEGORY_IN: new FormControl([]),
      CUSTOMER: new FormControl(''),
      // DUMMY_FILTER_ONE: new FormControl(),  // DUMMY_FILTER_ONE IS USED FOR CUSTOMER-WAREHOUSE 
      EXPENSE_MODE_IN: new FormControl(''),
      USER_NAME_IN: new FormControl(''),
      VENDOR_NAME_IN: new FormControl(''),
      VENDOR_CODE: new FormControl(''),
      EMAIL_IN: new FormControl(''),
      MOBILE_NUMBER: new FormControl(''),
      BUDGET_TYPE: new FormControl(''),
      DESIGNATION_IN: new FormControl(''),
      OWNERSHIP_TYPE_IN: new FormControl(''),
      WAREHOUSE_TYPE: new FormControl(''),
      DEPARTMENT_IN: new FormControl(''),
      USER_ROLE: new FormControl(''),
      USER_ID_IN: new FormControl(''),
      USER_NAME: new FormControl(''),
      EMPLOYEE_CODE: new FormControl(''),
      ACCOUNT_CODE_IN: new FormControl(''),
      INVOICE_NUMBER: new FormControl(''),
      VENDOR_INVOICE_IN: new FormControl(''),
      INVOICE_NUMBER_LIKE: new FormControl(''),
      VENDOR_ID_IN: new FormControl(''),
      ORDER_NUMBER_IN: new FormControl(''),
      NAME_IN: new FormControl(),
      CATEGORY: new FormControl(),
      DUMMY_FILTER_ONE: new FormControl(),  // DUMMY_FILTER_ONE IS USED FOR DATE FILTER 
      DATE_RANGE: new FormControl([]) ,
      INVOICE_IN: new FormControl(),
      CITY_NAME: new FormControl(),
      // STATE_IN: new FormControl(),
      CITY_CODE: new FormControl(),
      ROUTE_CODE_IN: new FormControl(),
      SOURCE_CITY_IN: new FormControl(),
      DESTINATION_CITY_IN: new FormControl(),
      CONTACT_EMAIL: new FormControl(''),
      CAPACITY_IN: new FormControl(''),
      USER_CODE: new FormControl(''),
      AADHAR_NUMBER_IN: new FormControl(''),
      // USER_TYPE: new FormControl('CUSTOMER'),
      COMPONENT_ID_IN: new FormControl(''),
      CALCULATION_TYPE_ID_IN: new FormControl(''),
      STATE_IN: new FormControl(''),
      COMPONENT_TYPE_IN: new FormControl(''),
      ORGANIZATION_ID_IN:new FormControl(''),
      SKILL_GROUP_ID_IN:new FormControl(''),
      SHIFT_ID_IN:new FormControl(''),
      REFRENCE_CODE_IN:new FormControl(''),
      OUTBOUND_TYPE_ID_IN: new FormControl(''),
      INPUT_TYPE_IN: new FormControl(''),
      REQUIRED: new FormControl(null),
      ATTRIBUTE_NAME: new FormControl(''),
      PRODUCT_NAME_IN: new FormControl(''),
      PRODUCT_SKU_LIKE: new FormControl(''),
      PRODUCT_UPC_IN: new FormControl(''),
      PRODUCT_ID_IN: new FormControl([]),
      INVENTORY_QUANTITY_GREATER_THAN: new FormControl('')
      
    });
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!)
    this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
    this.wareHouseList = JSON.parse(localStorage.getItem('wareHouseList')!);
    this.accountLists = JSON.parse(localStorage.getItem('accountList')!);
    this.sendCatagoryId = this.setId()
    console.log(this.sendCatagoryId,'this.sendCatagoryId')
    // this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())
  }

  ngOnInit(): void {
  
    if(this.showWarehouse){
      this.getWarehouseList()
    }
    if(this.showRoleName){
      // this.getroleList()
    }
    if(this.showCustomer){
      this.getaccountsList();
    }
    if(this.showCurrentApproval || this.showUserAgeing){
      this.getEmployeesList()
    }
    if(this.showCreatedBy || this.showBusinessOwner){
      this.getEmployeesList()
    }
    if(this.showInvoiceNo || this.showVendor || this.showInvoiceId  ){
      this.getVendors()
    }
    if(this.orderStatus){
      // this.getStatus()
    }
    if(this.showComponentType){
      this.getComponentType()
    }
    if(this.showOrganization){
      this.getOrganization()
    }
    if(this.showDesignation){
      this.getDesignation()
    }
     if(this.skillGroup){
      this.getSkillGroup()
    }
    if(this.showShift){
      this.getShift()
    }
    if(this.showMapping){
      this.getMappingInfo()
    }
    
    if(this.routeCode){
      // this.getLocations()
    }
    const categoryData = JSON.parse(localStorage.getItem('category')!);
    if (categoryData?.length>0) {
      this.category = categoryData;
    }

    // Tab service
    const activeTabIndex = this.tabService.activeTab;
    const activeTab = this.tabService.tabs[activeTabIndex];
    if (this.persistFilters && activeTab?.filterData) {
      this.warehouseFilter = activeTab.filterData;
      
      this.tabFilter = this.tabService.transformFiltersArrayToObject(activeTab.filterData);
      this.patchSavedFilters(this.tabFilter);
      console.log(this.searchForm)
      this.filterChange.emit(activeTab.filterData);
    }
    else{
      this.filterChange.emit([]);
    }
    this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : ''

    // call API when verdor type 
      this.vendorInput$.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(searchText => {
          this.onSearchVendor(searchText);
        });

         // call API when verdor type 
      this.EmpInput$.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(searchText => {
        this.onSearchEmp(searchText);
      });
  }

  patchSavedFilters(savedFilters: any): void {
    Object.entries(savedFilters || {}).forEach(([key, value]) => {
      const control = this.searchForm.get(key);

      if (!control || value === null || value === undefined || value === '') {
        return;
      }

      control.setValue(
        this.getSavedFilterControlValue(key, value)
      );

      if (key === 'DUMMY_FILTER_THREE') {
        this.applySavedDateFilterOption(String(value));
      }
    });
  }

  getSavedFilterControlValue(key: string, value: any): any {
    if (this.showOutboundAttributes && key === 'STATUS_IN') {
      return String(value).split(',');
    }
    if (this.showOutboundAttributes && ['OUTBOUND_TYPE_ID_IN', 'CATEGORY_ID_IN', 'INPUT_TYPE_IN', 'ATTRIBUTE_NAME', 'REQUIRED'].includes(key)) {
      return String(value);
    }
    if (key === 'DUMMY_FILTER_TWO') {
      const date = new Date(value as string | number);
      return isNaN(date.getTime()) ? value : date;
    }

    if (key === 'MAPPING_IN') {
      return this.toNumberIfNumeric(value);
    }

    if (this.isTextFilterKey(key) || this.isStatusFilterKey(key)) {
      return value;
    }

    if (this.isMultiSelectFilterKey(key)) {
      return String(value)
        .split(',')
        .filter((item: string) => item !== '')
        .map((item: string) => this.toNumberIfNumeric(item));
    }

    return this.toNumberIfNumeric(value);
  }

  isTextFilterKey(key: string): boolean {
    return [
      'ACCOUNT_CODE_IN',
      'USER_NAME_IN',
      'EMAIL_IN',
      'MOBILE_NUMBER',
      'BUDGET_TYPE',
      'USER_NAME',
      'EMPLOYEE_CODE',
      'INVOICE_NUMBER',
      'VENDOR_INVOICE_IN',
      'INVOICE_NUMBER_LIKE',
      'NAME_IN',
      'INVOICE_IN',
      'VENDOR_NAME_IN',
      'VENDOR_CODE',
      'ORDER_NUMBER_IN',
      'CITY_NAME',
      'CITY_CODE',
      'ROUTE_CODE_IN',
      'SOURCE_CITY_IN',
      'DESTINATION_CITY_IN',
      'CONTACT_EMAIL',
      'CAPACITY_IN',
      'USER_CODE',
      'AADHAR_NUMBER_IN',
      'USER_TYPE',
      'STATE_IN',
      'COMPONENT_TYPE_IN',
      'REFRENCE_CODE_IN'
    ].includes(key);
  }

  isStatusFilterKey(key: string): boolean {
    return key === 'STATUS_IN' || key === 'APPROVAL_STATUS';
  }

  isMultiSelectFilterKey(key: string): boolean {
    if (key === 'ORGANIZATION_ID_IN') {
      return this.showOrganization || (this.showMapping && this.mappingMultiple);
    }

    return [
      'CATEGORY_IN',
      'CATEGORY_ID_IN',
      'PRODUCT_CATEGORY_IN',
      'PRODUCT_ID_IN',
      'ZONE_IN',
      'REGION_IN',
      'CITY',
      'EXPENSE_IN',
      'YEAR_IN',
      'EXPENSE_MODE_IN',
      'OWNERSHIP_TYPE_IN',
      'DEPARTMENT_IN',
      'USER_ROLE',
      'USER_ID_IN',
      'VENDOR_ID_IN',
      'DESIGNATION_IN',
      'SKILL_GROUP_ID_IN',
      'SHIFT_ID_IN'
    ].includes(key);
  }

  toNumberIfNumeric(value: any): any {
    if (typeof value === 'number') {
      return value;
    }

    const stringValue = String(value);
    const numberValue = Number(stringValue);

    return stringValue.trim() !== '' && !Number.isNaN(numberValue)
      ? numberValue
      : value;
  }

  applySavedDateFilterOption(value: string): void {
    this.selectedOption = value;
    this.showCustomDateRange = this.selectedOption === 'custom';

    if (this.selectedOption === 'custom') {
      if (this.searchForm.controls['CREATED_FROM_DATE'].value) {
        const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['CREATED_FROM_DATE'].value);
        this.searchForm.controls['CREATED_FROM_DATE'].setValue(formattedDate);
      }

      if (this.searchForm.controls['CREATED_TO_DATE'].value) {
        const formattedDate = this.sharedService.convertToISOFormat(this.searchForm.controls['CREATED_TO_DATE'].value);
        this.searchForm.controls['CREATED_TO_DATE'].setValue(formattedDate);
      }

      return;
    }

    if (this.searchForm.controls['CREATED_FROM_DATE'].value) {
      const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['CREATED_FROM_DATE'].value);
      this.searchForm.controls['CREATED_FROM_DATE'].setValue(formattedDate);
    }

    if (this.searchForm.controls['CREATED_TO_DATE'].value) {
      const formattedDate = this.sharedService.convertToDateFormat(this.searchForm.controls['CREATED_TO_DATE'].value);
      this.searchForm.controls['CREATED_TO_DATE'].setValue(formattedDate);
    }
  }

  onSubmit() {
  const range = this.searchForm.value.DATE_RANGE;

    // console.log(this.searchForm.value) 
    // this.searchForm.removeControl('WAREHOUSEMAPPING')
    // this.searchForm.controls['MONTH'].setValue('')
    const formattedFilters = Object.entries(this.searchForm.value).reduce<any[]>((acc, [key, value]) => {
      if (value || value === 0) {
        // console.log('key',key)
        if (key === 'FROM_DATE' || key === 'TO_DATE' || key === 'CREATED_FROM_DATE' || key === 'CREATED_TO_DATE' || key === 'DATE_RANGE') {
          acc.push({
            key: key,
            // dateTimeValue: value
            dateTimeValue: moment(value).format('DD-MM-YYYY HH:mm:ss Z').replace(/(\+\d{2}):(\d{2})/, '$1$2')
          });
        } else {
          const filterValue = Array.isArray(value) ? value.join(',') : String(value);
          acc.push({
            key: key,
            value: filterValue
          });
    
          // Add extra field if key is USER_ID_IN
          if (key === 'USER_ID_IN' && this.showCurrentApproval) {
            acc.push({
              key: 'APPROVAL_STATUS',
              value: '1'
            });
          }
        }
      }
      
     
      return acc;
    }, []);
     if (this.rangeDates && this.rangeDates.length === 2) {
      const [startDate, endDate] = this.rangeDates;
      const formatToUTC = (date: Date): string => {
            const dd = String(date.getUTCDate()).padStart(2, '0');
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
            const yyyy = date.getUTCFullYear();
            return `${dd}-${mm}-${yyyy} +0000`;
          };
       if (startDate && endDate) {
          formattedFilters.push(
            {
              key: 'FROM_DATE1',
              dateValue: formatToUTC(startDate)
            },
            {
              key: 'TO_DATE1',
              dateValue: formatToUTC(endDate)
            }
          );
        }

        
      }

      if (this.dateRangePayload?.length) {
        formattedFilters.push(...this.dateRangePayload);
      }
    const filteredData = formattedFilters.filter(item => item.value !== "");
    const updatedFilters = filteredData
      .filter(item => item.key !== "DUMMY_FILTER_TWO" && item.key !== "DATE_RANGE")
      .map(item => this.useAccountIdFilter && item.key === 'CUSTOMER_ID_IN'
        ? { ...item, key: 'ACCOUNT_ID_IN' }
        : item);

    this.filterChange.emit(updatedFilters);
    console.log('updatedFilters',updatedFilters)
    if (this.persistFilters) {
      const activeTabIndex = this.tabService?.activeTab;
      this.tabService.updateFilterData(activeTabIndex, updatedFilters);
    }
    this.searchDropDownToggle = !this.searchDropDownToggle;
  }

  setMonth(event:any){
    const { startDate, endDate } = this.sharedService.getStartAndEndDates(event);
    const sendStartDate = this.sharedService.parseDateStringToDate(startDate)
    const sendEndDate = this.sharedService.parseDateStringToDate(endDate)
    this.searchForm.controls['FROM_DATE'].setValue(sendStartDate)
    this.searchForm.controls['TO_DATE'].setValue(sendEndDate)
  }

  onReset() {
    // this.searchForm.addControl('WAREHOUSEMAPPING', new FormControl(''));
    this.showCustomDateRange = false
    this.selectedOption = "";
    this.searchForm.reset();
    this.resetFilters.emit();
    if (this.persistFilters) {
      const activeTabIndex = this.tabService?.activeTab;
      this.tabService.updateFilterData(activeTabIndex, []);
    }
    this.searchDropDownToggle = !this.searchDropDownToggle;
    this.searchFilterList = []
    this.rangeDates = []
    this.dateRangePayload = []
  }

  setId(){
    const obj  = []
    if(this.showZone){
      obj.push(this.allCatagory.zone.id)
    }
    if(this.showFY){
      obj.push(this.allCatagory.financialYear.id)
    }
    if(this.showRegion){
      obj.push(this.allCatagory.region.id)
    }
    if(this.showCity){
      obj.push(this.allCatagory.city.id)
    }
    if(this.showCalculationType){
      obj.push(this.allCatagory.calculationType.id)
    }
    return obj
  }
  getQuickCodeListByCategoryId(ids:any) {
    this.masterService
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        this.zoneList = data?.responseObject?.zone
        this.financialYearList = data?.responseObject?.financialYear
        this.regionList = data?.responseObject?.region
        this.cityList = data?.responseObject?.city
        this.budgetType = data?.responseObject?.budgetType
        // this.designation = data?.responseObject?.designation
        this.ownershipType = data?.responseObject?.ownershipType
        this.whType = data?.responseObject?.warehouseType
        this.department = data?.responseObject?.department
        this.expenseCategory = data?.responseObject?.expenseCategory
        this.expenseMode = data?.responseObject?.expenseMode
        this.calculationTypesList = data?.responseObject?.calculationType
        this.stateList = data?.responseObject?.state
      });
  }



  getaccountsList(){
    this.masterService
      .getAccounts([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.accountLists = data?.responseObject?.content;
      }, err => {
        // console.log(err);
        this.accountLists = []
      });
  }
  getDesignation(){
    this.wageService
      .getDesignation([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.designation = data?.responseObject?.content;
      }, err => {
        // console.log(err);
        this.designation = []
      });
  }
  getSkillGroup(){
    this.wageService
      .getCategory([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.skillGroupList = data?.responseObject?.content;
      }, err => {
        // console.log(err);
        this.skillGroupList = []
      });
  }
  getShift(){
    this.wageService
      .getShift([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.shiftList = data?.responseObject?.content;
      }, err => {
        this.shiftList = []
      });
  }
  getWarehouseList(){
     this.masterService
      .getWarehouseList([], 0, 500, 'id', 'ASC')
      .subscribe((data: any) => {
        this.wareHouseList = data?.responseObject?.content;
      }, err => {
        // console.log(err);
        this.wareHouseList = []
      });
  }

  selectWarehouse(event:any){
    console.log(this.searchForm.value.DUMMY_FILTER_ONE)
    const WAREHOUSEMAPPING =
      this.searchForm.value.DUMMY_FILTER_ONE;
    const transformedMapping = Array.isArray(WAREHOUSEMAPPING)
      ? WAREHOUSEMAPPING.map((wh: any) => ({ 
        clientId: wh?.id,
        "warehouseId": wh?.warehouseId
      })) 
      : [];
    const clientIds = transformedMapping.map(item => item.clientId);
    const clientIdString = clientIds.join(',');
    this.searchForm.controls['CUSTOMER_ID_IN'].setValue(clientIdString);
    const warehouseIds = transformedMapping.map(item => item.warehouseId);
    const warehouseIdString = warehouseIds.join(',');
    this.searchForm.controls['WAREHOUSE_ID_IN'].setValue(warehouseIdString);
    console.log(this.searchForm)
  }

  getroleList() {
    const obj = [
      {
        "key": "PLATFORM",
        "value": "ems"
      }
     ];
    this.roleManagementService.getRolelist(obj,0,500).subscribe(
      (res:any) => {
        this.roleList = res?.responseObject.content
      }
    );
  }
  getVendors() {
     this.postData = [
      // {    
      //   "key": "USER_TYPE",
      //   "value": "2"
      // },
      // {
      //   "key":"PLATFORM_IN",
      //   "value":"ems"
      // }
    ]

    if (this.filters) {
      Object.values(this.filters).forEach((filter: any) => {
        this.postData.push(filter);
      });
    }
    this.masterService
      .getVendorInfo(this.postData, 0, '50','id','ASC')
      .subscribe((data: any) => {
        this.vendorsList = data?.responseObject?.content;
      });
  }
  getEmployeesList() {
    const postData: any[] = [
      
    ]

    this.masterService
      .getUsers(postData, 0, 20,'id','DESC')
      .subscribe((data: any) => {
        this.EmployeesList = data?.responseObject?.content;
      });
  }

  EmpInput$ = new Subject<string>();
  vendorInput$ = new Subject<string>();
  // vendorsList: any[] = [];
  // isLoading = false;
  onSearchVendor(term: string) {
    // this.isLoading = true;
  
    const postData: any[] = [
      
    ];
  
    if (term && term.trim().length > 0) {
      postData.push({
        key: 'NAME_IN',
        value: term.trim()
      });
    }
  
    this.masterService.getUsers(postData, 0, 50, 'id', 'DESC').subscribe(
      (data: any) => {
        this.vendorsList = data?.responseObject?.content || [];
        // this.isLoading = false;
      },
      () => {
        this.vendorsList = [];
        // this.isLoading = false;
      }
    );
  }

  onSearchEmp(term: string) {
    // this.isLoading = true;
  
    const postData = [
      {
        key: 'USER_TYPE',
        value: '1'
      },
      {
        key: 'STATUS_IN',
        value: '1'
      },
      {
        key: 'PLATFORM_IN',
        value: 'ems'
      }
    ];
  
    if (term && term.trim().length > 0) {
      postData.push({
        key: 'NAME_IN',
        value: term.trim()
      });
    }
  
    this.masterService.getUsers(postData, 0, 50, 'id', 'DESC').subscribe(
      (data: any) => {
        this.EmployeesList = data?.responseObject?.content || [];
        // this.isLoading = false;
      },
      () => {
        this.EmployeesList = [];
        // this.isLoading = false;
      }
    );
  }

onSearch(term: any) {
  if (!term?.term || typeof term?.term !== 'string') {
    // Reset to full list when search is cleared or invalid
    this.searchFilterList = [...this.accountMappingList];
    return;
  }
  const lower = term?.term.toLowerCase();
  this.searchFilterList = this.accountMappingList.filter((d: any) =>
    d.accountName?.toLowerCase().includes(lower) ||
    d.warehouseName?.toLowerCase().includes(lower)
  );
}
onExpenseSearch(term: any) {
  if (!term?.term || typeof term?.term !== 'string') {
    // Reset to full list when search is cleared or invalid
    this.searchExpenseFilterList = [...this.expenseTypeList];
    return;
  }
  const lower = term?.term.toLowerCase();
  this.searchExpenseFilterList = this.expenseTypeList.filter((d: any) =>
    d.expenseName?.toLowerCase().includes(lower) 
  );
}

  onSelectAll(type: string, list: any[]) {
    console.log(this.searchFilterList)
  if (this.searchFilterList && this.searchFilterList.length && type == 'MAPPING_IN') {
    const newSelectedValues  = this.searchFilterList.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    console.log(control)
    if (control) {
        const prevSelectedValues = control.value || [];
        const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(mergedValues);
     
    } else {
      // console.warn(`Form control '${type}' does not exist.`);
    }
    // console.log(`Selected values for '${type}':`, selectedValues);
  } else if(type == 'MAPPING_IN' && this.searchFilterList == undefined){
    const newSelectedValues  = list.map((item: any) => item?.id);
        const control = this.searchForm.get(type);
        if (control) {
            control.setValue(newSelectedValues);
        }   
  }else {
    const newSelectedValues  = list.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        // const prevSelectedValues = control.value || [];
        // const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(newSelectedValues);
      
    }

    // console.log(`No items found in the provided list for '${type}'.`);
  }
}


onSelectAllExpense(type: string, list: any[]) {
  if (this.searchExpenseFilterList && this.searchExpenseFilterList.length && type == 'EXPENSE_IN') {
    const newSelectedValues  = this.searchExpenseFilterList.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        const prevSelectedValues = control.value || [];
        const mergedValues = Array.from(new Set([...prevSelectedValues, ...newSelectedValues ]));
        control.setValue(mergedValues);
     
    } else {
    }
  } else if(type == 'EXPENSE_IN' && this.searchExpenseFilterList == undefined){
    const newSelectedValues  = list.map((item: any) => item?.id);
        const control = this.searchForm.get(type);
        if (control) {
            control.setValue(newSelectedValues);
        }   
  }else {
    const newSelectedValues  = list.map((item: any) => item?.id);
    const control = this.searchForm.get(type);
    if (control) {
        control.setValue(newSelectedValues);
      
    }
  }
}
  onClearAll(type: string) {
  const control = this.searchForm.get(type);
  if (control) {
    control.setValue([]);
  }
}

onOptionChange(event: any): void {
  this.selectedOption = event.target.value;
  this.showCustomDateRange = this.selectedOption === 'custom';

  if (this.selectedOption !== 'custom') {
    let dateRange = this.sharedService.getPredefinedDateRange(this.selectedOption);
    if (dateRange) {
      this.searchForm.patchValue({
        CREATED_FROM_DATE: dateRange.startDate,
        CREATED_TO_DATE: dateRange.endDate
      });
      console.log(dateRange);
    }
  }
}

selectRange(event: any) {
  const range = this.searchForm.value.DATE_RANGE;
  if (range && range[0] && range[1]) {
    const fromDate = moment(range[0]).format('DD-MM-yyyy ZZ')
    const toDate = moment(range[1]).format('DD-MM-yyyy ZZ')

    this.dateRangePayload = [
      {
        key: 'FROM_DATE',
        dateValue: fromDate
      },
      {
        key: 'TO_DATE',
        dateValue: toDate
      }
    ];
  } else {
    this.dateRangePayload = [];
  }
}


  getStatus() {
    this.masterService
      .getStatus()
      .subscribe((data: any) => {
        // this.statusList = data?.responseObject;
      });
  }

getComponentType(){
this.wageService.getComponents([],0,500,'id','DESC')
  .subscribe((data: any) => {
    this.componentTypesList = data?.responseObject?.content;
  });
}
getOrganization(){
this.wageService.getOrganization([],0,500,'id','DESC')
  .subscribe((data: any) => {
    this.organizationList = data?.responseObject?.content;
  });
}
getMappingInfo(){
  const postData = [
  {
    "key": "STATUS_IN",
    "value": "Active"
   }
]
this.wageService.getMappingInfo(postData,0,500,'id','DESC')
  .subscribe((data: any) => {
    this.mappingList = data?.responseObject?.content;
  });
}
  
}
